<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-if="isDetail" class="page-number">
    <span class="number">01</span>
  </div>
  <div v-else class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1026 45">
    <g id="yema6" transform="translate(0 -12)">
      <g id="组_4660" data-name="组 4660" transform="translate(-82 -282)">
        <rect id="矩形_2890" data-name="矩形 2890" width="980" height="6" transform="translate(82 314)" fill="var(--theme-color-1)"/>
        <text id="_01" data-name="01" transform="translate(1075 328)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
      </g>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.svg-block {
  width: 420px !important;
  position: absolute;
  bottom: 10px;
  left: 0;
  padding: 0 20px;
}
.page-number {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &::before {
    content: '';
    flex-grow: 1;
    height: 6px;
    background-color: var(--theme-color-1);
  }
}
.number {
  padding-left: 5px;
  flex-shrink: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--theme-color-1);
}
</style>
